import React, { useEffect, useRef, useMemo } from "react";
import * as echarts from 'echarts';
import { valueFormat } from "@/pages/intelligence/utils/commonUtils";
import { useIntl } from "umi";
export const tooltipFormatter = (params: any[], option?: any) => {
  const { headerRightTitle, headerLeftTitle } = option || {};
  let rowStr = '';
  for (let i = 0; i < params?.length; i++) {
    const t = params?.[i];
    const cover = t?.cover;
    const name = t?.name;

    rowStr += `
      <section class="dbi-tooltip-body-item" >
        <section class="dbi-tooltip-body-item-left">
          <i class="dbi-tooltip-body-item-left-dot" style="background-color: ${t?.color};"></i>
          ${cover ? `<img class="dbi-tooltip-body-item-left-img" src="${cover}" alt="" />` : ''}
          <span class="dbi-tooltip-body-item-left-name">${name || '-'}</span>
        </section>
        <section class="dbi-tooltip-body-item-right">${valueFormat(t?.value) || '-'}</section>
      </section>
    `;
  }
  const htmlStr = `
    <section class="dbi-stack-bar-echarts-tooltip"  >
      <section class="dbi-tooltip-header">
        <section class="dbi-tooltip-header-left">${headerLeftTitle || ''}</section>
        <section class="dbi-tooltip-header-right">${headerRightTitle || 'Revenue'}</section>
      </section>
      <section class="dbi-tooltip-body">${rowStr}</section>
    </section>
  `;

  return htmlStr;
};

export default function EmptyPieChart(props: any) {
  const {
    data,
    year,
    text,
    color,
    chartStyle = {
      height: '230px',
      width: '100%',
    }
  } = props;
  const { formatMessage } = useIntl()
  const ref = useRef<HTMLDivElement>(null);
  const dataForTooltip = useMemo(() => {
    const list = data;
    if (!Array.isArray(list)) return [];
    return list.map((item, index) => ({ name: item?.name, value: item?.value, color: color[index] }));
  }, [color, data]);
  const getOptions = () => ({
    tooltip: {
      trigger: 'item',
      showDelay: 0,
      hideDelay: 0,
      transitionDuration: 0.2,
      axisPointer: {
        type: 'line',
      },
      enterable: false,
      borderColor: 'transparent',
      confine: true,
      formatter: () => tooltipFormatter(dataForTooltip, { headerLeftTitle: year, headerRightTitle: formatMessage({ id: 'dbi-sm-revenue' }) }),
      backgroundColor: 'rgba(0,0,0,0.75)'
    },
    legend: {
      show: false,
    },
    graphic: {
      type: "text",
      left: "center",
      top: "center",
      style: {
        text,
        textAlign: "center",
        fill: '#262832',
        fontSize: 12,
        fontWeight: "bold",
      }
    },
    itemStyle: {
      borderRadius: 5,
      borderColor: '#fff',
      borderWidth: 2
    },
    grid: {
      top: '3%',
      right: '5%',
      width: '95%',
      bottom: 30,
      containLabel: true,
    },
    series: [{
      name: '',
      type: 'pie',
      radius: ['45%', '70%'],
      // center: ['40%', '50%'],
      clockwise: false,
      label: {
        alignTo: 'labelLine',
        position: 'outer',
        formatter: (params) => {
          if (params.name == 'Other') {
            return '';
          }
          return `{b|${params.percent}%}\n`;

        },
        minMargin: 5,
        bleedMargin: -20,
        lineHeight: 20,
        distanceToLabelLine: -55,
        rich: {
          b: {
            fontSize: 12,
            color: color[1],
          },
        },
      },
      labelLine: {
        length: 20,
        length2: 60,
        maxSurfaceAngle: 10,
      },
      data,
    }],
    color,
  })

  const handleResize = (chart) => {
    if (ref?.current) {
      chart.resize();
    }
  };

  useEffect(() => {
    let myChart;
    let listener: null | (() => void) = null;

    if (ref.current) {
      const options = getOptions();
      // canvas
      myChart = echarts.init(ref.current, undefined, { renderer: 'canvas' });
      myChart.setOption(options, { notMerge: true });
      listener = () => {
        handleResize(myChart);
      };

      window.addEventListener('resize', listener);
    }

    return () => {
      if (myChart && listener !== null) {
        window.removeEventListener('resize', listener);
        myChart.off();
      }
    };
  }, [props]);

  return (
    <div style={{ ...chartStyle }}>
      <div ref={ref} style={chartStyle}></div>
    </div>
  );
}